import cn from "classnames";
import { StepperProps } from "./types";
import { Step } from "./step";
import { useStepWidth } from "./hooks";
import styles from "./styles.module.scss";

export const Stepper = ({
  steps,
  className,
  dataTestId = "stepper",
  onClick,
}: StepperProps) => {
  const { stepWidth, stepperRef } = useStepWidth(steps.length);

  return (
    <div className={styles.stepper} data-test-id={dataTestId}>
      <div ref={stepperRef} className={cn(styles["stepper-inner"], className)}>
        {steps.map(({ label, isPassed, isActive, buttonContent }, index) => {
          const isFirstStep = index === 0;

          return (
            <Step
              key={label}
              width={stepWidth}
              dataTestId={dataTestId}
              step={index}
              label={label}
              isFirstStep={isFirstStep}
              isLastStep={index === steps.length - 1}
              isActive={isActive}
              isPassed={isPassed}
              buttonContent={buttonContent}
              isDisabled={isFirstStep ? false : !steps[index - 1].isPassed}
              onClick={onClick}
            />
          );
        })}
      </div>
    </div>
  );
};
